import React from "react";
import "./textView.css";

const TextView = (props)=>
{
return(

    <div className="textView">
        <h3 style={{fontSize:props.fontSize,fontWeight:"600"}}>{props.header?props.title:" "}</h3>
       <p style={{fontSize:props.fontSize}}>
           {props.textView}
 
       </p>
    </div>
);
}

export default TextView